<template>
  <div>
    <div class="top">费用详情</div>
    <div class="contaa">
      <div class="top1">
        <div class="title">{{ name }}</div>
        <div class="time">{{ classa }}</div>
      </div>
      <div class="top2" v-if="dataimfo.length > 0">
        <div class="toptitle" style="border-bottom: 1px solid #eeee">
          <div class="title">{{ title }}</div>
          <div class="time">缴费截止：{{ creattime }}</div>
        </div>
        <div class="kximfo">
          <!-- <van-checkbox-group
            class="onedata"
            v-model="checked"
            ref="checkboxGroup"
            @change="checkone"
          >
            <div v-for="item in dataimfo" :key="item.itemid">
              <van-checkbox
                :name="item"
                class="singlecheck"
                checked-color="#dd0000"
                v-if="!item.isRequired"
                ><span class="dataname">{{ item.itemName }}</span
                ><span class="dataprice"
                  >￥{{ (item.price / 100).toFixed(2) }}</span
                ></van-checkbox
              >
              <van-checkbox
                :name="item"
                v-else
                disabled
                class="singlecheck"
                checked-color="#dd0000"
                ><span class="dataname">{{ item.itemName }}</span
                ><span class="dataprice"
                  >￥{{ (item.price / 100).toFixed(2) }}</span
                ></van-checkbox
              >
            </div>
          </van-checkbox-group> -->
          <van-checkbox-group
            v-model="checked"
            @change="checkone"
            ref="checkboxGroup"
          >
            <van-cell-group inset>
              <van-cell
                v-for="(item, index) in dataimfo"
                clickable
                :key="item.itemid"
                :title="item.itemName"
                @click="toggle(index)"
              >
                <span class="dataprice"
                  >￥{{ (item.price / 100).toFixed(2) }}</span
                >
                <template #right-icon>
                  <van-checkbox
                    v-if="!item.isRequired"
                    :name="item"
                    :ref="(el) => (checkboxRefs[index] = el)"
                    @click.stop
                    checked-color="#dd0000"
                  />
                  <van-checkbox
                    v-else
                    disabled
                    :name="item"
                    :ref="(el) => (checkboxRefs[index] = el)"
                    @click.stop
                    checked-color="#dd0000"
                  />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          <van-checkbox
            v-model="allchecked"
            @click="checkAll"
            class="checkall"
            checked-color="#dd0000"
            ><span class="dataname">全选</span></van-checkbox
          >
        </div>

        <div class="heji">
          <span>合计：</span
          ><span class="hejiprice">￥{{ (allfee / 100).toFixed(2) }}</span>
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无待缴费" />
      </div>
      <div class="top3" v-if="dataimfo.length > 0">
        <div class="toptitle">缴费说明</div>
        <div class="toptitle">
          <span class="zistyle">{{ note }}</span>
        </div>
      </div>
    </div>
    <div class="surebtn" v-if="dataimfo.length > 0">
      <van-button type="danger" block @click="paymoney" v-if="allfee >= 0"
        >确认缴费</van-button
      >
      <van-button type="danger" block v-else disabled>确认缴费</van-button>
    </div>
  </div>
</template>

<script>
 import { Toast } from 'vant'; 
export default {
  data() {
    return {
      dataimfo: [],
      bxdata: [],
      allfee: 0,
      bxprice: 0,
      kxprice: 0,
      datafee: [],
      creattime: "",
      title: "",
      note: "",
      checked: [],
      allchecked: false,
      name: "",
      classa: "",
    };
  },

  mounted() {
    this.getimfo();
  },

  methods: {
    toggle(index) {
      checkboxRefs.value[index].toggle();
    },
    //全选，反选
    checkAll() {
      if (this.allchecked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
        // this.kxprice = 0;
        this.checked = this.bxdata;
      }
    },
    //选择某一个
    checkone(value) {
      console.log(this.checked);
      this.allfee = 0;
      if (this.checked.length == this.dataimfo.length) {
        this.allchecked = true;
        // this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.allchecked = false;
      }
      if (this.checked.length > 0) {
        this.checked.forEach((item) => {
          this.allfee += item.price;
        });
      }
    },
    // getprice() {
    //   this.allfee = this.bxprice + this.kxprice;
    // },
    //获取详情
    getimfo() {
      console.log(this.$route.query.id, 777);
      (this.name = sessionStorage.getItem("name")),
        (this.classa = sessionStorage.getItem("class"));
      let id = this.$route.query.id;
      let studentid = this.$route.query.studentid;
      this.fetchget(`/api/Order/mypaymentdetail`, {
        id: id,
        studentid: studentid,
      }).then((res) => {
        if (res.code > 0) {
          this.dataimfo = res.data.items;
          this.creattime = res.data.endDate.split("T")[0];
          this.title = res.data.title;
          this.note = res.data.note;
          res.data.items.forEach((item) => {
            if (item.isRequired) {
              this.bxdata.push(item);
              // this.bxprice += item.price;
              this.checked = this.bxdata;
              this.allfee += item.price;
            }
            // else if (!item.isRequired) {
            //   this.dataimfo.push(item);
            // }
          });
          // this.allfee = this.bxprice + this.kxprice;
        } else {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        }
      });
    },
    paymoney() {
      // console.log("2秒内点击无数次，都只会触发一次");
      let brr = [];
      // let arr = [];
      this.checked.forEach((item) => {
        brr.push(item.itemid);
      });
      // this.bxdata.forEach((item) => {
      //   arr.push(item.itemid);
      // });
      // this.newflag = false;
      let data = {
        // name: sessionStorage.getItem("name"),
        // idCard: sessionStorage.getItem("idCard"),
        // orgId: sessionStorage.getItem("orgId"),
        payMethod: "wx",
        payItems: brr,
        totalFee: this.allfee,
        paymentId: this.$route.query.id,
        studentid: this.$route.query.studentid,
      };
      console.log(data);
      if (this.allfee > 0) {
        Toast.loading({
          message: "订单创建中……...",
          forbidClick: true,
        });

        this.fetchpost("/api/Order/create", data).then((res) => {
          if (res.code < 0) {
            this.$notify({
              type: "danger",
              message: res.msg,
              color: "#ad0000",
              background: "#ffe1e1",
            });
          } else {
            Toast.loading({
              message: "已经创建，跳转中...",
              forbidClick: true,
            });
            brr = [];

            let path = "pages/index/index?id=" + res.data;
            //跳转微信小程序
            window.AppBridgeGlobal.gotoWXMiniProgram(
              {
                username: "gh_d08e9c6e1014", //小程序原始ID
                path: path, //小程序路径，可没有，如果没有表示跳转小程序首页
                type: "0", //小程序类型 0:正式版  1:体验版  2测试版
              },
              function (jumpRes) {
                if (jumpRes.tmCode === 200) {
                  Toast.loading({
                    duration: 3000,
                    message: "正在跳转...",
                    forbidClick: true,
                  });
                } else {
                  this.$notify({
                    type: "danger",
                    message: jumpRes.tmMsg,
                  });
                }
                /* {
            tmCode: 200, //200：成功；其他：失败
            tmMsg: "", //提示文字信息
        }*/
              }
            );

            window.location.href = res.msg;
          }
        });
      } else {
        this.$notify({
          type: "danger",
          message: "家长可不必缴费,等下次抵扣",
          color: "#ad0000",
          background: "#ffe1e1",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.van-cell__value {
  text-align: left;
}
.dataprice {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #dd0000;
}
p {
  font-size: 15px;
  color: #434343;
  line-height: 30px;
}
.surebtn {
  padding: 0 15px;
  // margin-top: 10px;
  position: relative;
  bottom: 20px;
}
.zistyle {
  color: #898989;
  font-weight: normal;
  font-size: 12px;
  // float: right;
}
.contaa {
  // height:calc(100% - #{$--operation-height});
  overflow-y: auto;
  min-height: 200px;
  margin-bottom: 50px;
}
.top {
  width: 375px;
  height: 44px;
  background-color: #dd0000;
  height: 44px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}
.top1 {
  width: 335px;
  height: 50px;
  background-color: #ffffff;
  margin-bottom: 7px;
  padding: 20px;
  .time {
    height: 20px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #90979d;
    margin-top: 10px;
  }
  .title {
    height: 20px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #000000;
  }
}
.top2 {
  width: 345px;
  background-color: #ffffff;
  padding: 0 15px;
  margin-bottom: 7px;

  .toptitle {
    width: 345px;
    height: 40px;
    text-align: left;
    color: #434343;
    font-size: 15px;
    font-weight: 600;
    line-height: 40px;
    .time {
      height: 40px;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #90979d;
      float: right;
    }
    .title {
      height: 40px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #000000;
      float: left;
      width: 180px;
      white-space: nowrap;
      /*溢出部分文字隐藏*/
      overflow: hidden;
      /*溢出部分省略号处理*/
      text-overflow: ellipsis;
    }
  }
  .checkall {
    line-height: 40px;
    height: 40px;
    font-size: 15px;
    padding: 0 15px;
    //   display: flex;
    // justify-content: space-around;
  }
  .bximfo {
    .singlecheck {
      line-height: 40px;
      height: 40px;
      font-size: 15px;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
    }
    .dataname {
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #000000;
    }
    .dataprice {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #dd0000;
      margin-left: 20px;
    }
  }
  .onedata {
    // display: flex;
    // justify-content: space-around;
    // line-height: 40px;
    margin-bottom: 10px;
    .singlecheck {
      line-height: 40px;
      height: 40px;
      font-size: 15px;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
    }
    .dataname {
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #000000;
    }
    .dataprice {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #dd0000;
      margin-left: 20px;
    }
  }
  .heji {
    width: 345px;
    height: 60px;
    background-color: #ffffff;
    font-size: 15px;
    text-align: right;
    line-height: 60px;
    font-weight: 600;
    border-top: 1px solid #eee;
    .hejiprice {
      font-size: 24px;
      font-weight: 600;
      color: #dd0000;
    }
  }
  .xiangqing {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 0px;
    color: #90979d;
  }
}
.top3 {
  width: 375px;
  .toptitle {
    padding: 0 15px;
    width: 345px;
    // height: 40px;
    text-align: left;
    color: #434343;
    font-size: 15px;
    font-weight: 600;
    line-height: 30px;
    background-color: #ffffff;
  }
}
</style>